const AbiUserSettingsApiUrls = {
  GET: ` ${process.env.REACT_APP_USER_ABI_URL}/abi/user-settings/get`,
  SAVE: `${process.env.REACT_APP_USER_ABI_URL}/abi/user-settings/save`,
  UPDATE: `${process.env.REACT_APP_USER_ABI_URL}/abi/user-settings/update`,
  UPDATE_ENTRY_NO: `${process.env.REACT_APP_USER_ABI_URL}/abi/user-settings/entry-number/update`,
};

export default AbiUserSettingsApiUrls
